<template>
  <div class="project">
    <div class="content" style="height:280px;margin:30px auto;margin-left:260px;">
      <div style="float:left;">
        <img src="../assets/jump.png">
      </div>
      <div style="float:left;margin-left:20px;color:#999;">
        <p style="font-size:28px;">
          亲！
        </p>
        <p style="font-size:18px;">
          正在为您跳转到，<a id="jump" target="_blank" rel="noreferrer" v-bind:href="jumpUrl"></a><span style="color:#2D8CF0;">{{orgname}}</span>项目详情页面......
        </p>
      </div>
    </div>
  </div>
</template>

<style scoped>
  @import "../style/project-detail.css";
</style>

<script>
  import { mapState } from 'vuex'
  import global from '../components/public/Common.vue';

  export default {
    name: 'author',
    computed: {
      // ...mapState({
      //   author: state => state.AuthorStore.author,
      //   other: state => state.AuthorStore.other,
      //   pathName: state => state.SelectStore.pathName
      // })
    },
    data() {
      return {
        projectDetailUrl:global.projectDetailUrl,
        orgname:this.$route.query.orgname,
        jumpUrl:this.$route.query.url
      }
    },
    created: function () {
      let _this = this;
      //return '<Redirect to={path:\'/projectDetail\',query: {id: _this.$route.query.url}} />';
      /*_this.$route.push({
        path: '/comments/' + id,
      });*/
    },
    mounted:function(){
      let _this = this;
      //return '<Redirect to={path:\'/projectDetail\',query: {id: _this.$route.query.url}} />';
      /*_this.$route.push({
        path: '/comments/' + id,
      });*/
      var url = _this.$route.query.url;
      setTimeout(function(){
        //window.open(url,'_self')
        $("#jump").click();
      },1000);
    },
    watch: {
      //'$route': 'fetchData'
    },
    methods: {

    },
    filters: {

    }
  }
</script>

<style lang="stylus">

</style>



// WEBPACK FOOTER //
// src/components/Jump.vue